import React, { useEffect, useRef, useState } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import { useForm } from "react-hook-form"
import RegisterService from "../../../shared/services/register-service"
import AuthService from "../../../shared/services/auth-service"
import Button from "../../../shared/components/atoms/button/button"
import StandardModal from "../../../shared/components/modals/standard-modal/standard-modal"
import StateUserModal from "../../../shared/components/modals/state-user-modal/state-user-modal"
import StepCodeVerification from "../../../shared/components/modals/step-code-verification/step-code-verification"
import { isAdviser } from "../../../shared/utils/getAdviserType"
import { siteUrl } from "../../../shared/utils/siteUrl"
import * as reCaptchaKey from "../../../shared/constants/reCaptcha"
import "./login-content.scss"
import SHA256 from 'crypto-js/sha256';
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"

const LoginContent = props => {
  const { register, handleSubmit, errors, setValue, getValues} = useForm()

  const [showPassword, setShowPassword] = useState(false)
  const [errorLogin, setErrorLogin] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const recaptchaRef = useRef(null)

  const MAIL_REGEX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
  const PHONE_REGEX = /^-{0,1}\d+$/

  const handleReloadCaptcha = async () => {
    await recaptchaRef.current.execute()
  }

  const handleChangeInputUser = username => {
    if (username !== "") {
      if (PHONE_REGEX.test(username)) {
        sessionStorage.setItem("currentUserNumeric", true)
      } else {
        sessionStorage.setItem("currentUserNumeric", false)
      }
    }
    sessionStorage.setItem("currentUserValue", username)
  }

  const mistakeCellByCountry = num => {
    return (
      num.toString().length < parseInt(process.env.MIN_DIGITS) ||
      num.toString().length > parseInt(process.env.MAX_DIGITS)
    )
  }

  const nextRedirect = () => {
    if (sessionStorage.getItem("NEXT_PAGE") !== null) {
      window.location.href = siteUrl + sessionStorage.getItem("NEXT_PAGE")
    } else {
      window.location.href = "/"
    }
  }

  const onSubmitLogin = data => {

    if (isLoading) return
    setIsLoading(true)

    setErrorLogin()
    handleChangeInputUser(data.username)

    const phoneMatchType =
      PHONE_REGEX.test(data.username) && !mistakeCellByCountry(data.username)
    const emailMatchType = MAIL_REGEX.test(data.username)
    if (!phoneMatchType && !emailMatchType) {
      setErrorLogin(" * Usuario no valido")
      setIsLoading(false)
      return
    }

    let inputPass = data.password
    let username = phoneMatchType
      ? process.env.COUNTRY_PHONE_PREFIX + data.username
      : data.username.toLocaleLowerCase()

    let payload = {
      email: username,
      password: inputPass,
      captcha: recaptchaRef.current.getValue(),
    }

    AuthService.authentication(payload)
      .then(res => {
        if (res.status === 400 || res.status === 404) {
          if (res.errorCode === "DEM023") {
            if (res.data && res.data === "EMAIL") {
              let payload2 = {
                username,
              }
              props.setModalActive(
                <StandardModal
                  title="Activa"
                  subtitle="TU USUARIO"
                  description="Debes activar tu usuario para que puedas acceder a tu cuenta, te hemos enviado un correo de activación. Ahora revisa el correo con el que te registraste."
                  button_title="Reenviar correo"
                  click={() => {
                    props.setModalActive(null)
                    RegisterService.codeVerificationResend(payload2).catch(
                      err => {
                        console.error(err)
                      },
                    )
                  }}
                />,
              )
            } else {
              props.setModalActive(
                <StepCodeVerification
                  email={username}
                  setSuccessRegisterModal={props.setModalActive}
                />,
              )
            }
            setIsLoading(false)
          } else if (res.errorCode === "DEM071") {
            props.setModalActive(
              <StandardModal
                title="Esperando"
                subtitle="AUTORIZACIÓN DE TUS PADRES"
                description="Aún estamos esperando por la autorización de tus padres. No olvides recordarles los pasos que deben seguir para que puedas comenzar a disfrutar de NosotrasOnline."
                button_title={
                  res.data === "SMS" ? "Reenviar SMS" : "Reenviar correo"
                }
                click={() => {
                  props.setModalActive(null)
                  RegisterService.parentResentConfirmation(
                    "?username=" + username,
                  )
                    .then(res => {
                      console.log(res.status)
                    })
                    .catch(err => {
                      console.error(err)
                    })
                }}
              />,
            )
          } else if (res.errorCode === "DEM018") {
            handleReloadCaptcha()
              .then(res => {
                onSubmitLogin(getValues())
              })
              .catch((e) => {
                console.error(e)
              })
          }else {
            setErrorLogin("* " + res.userMessage)
            handleReloadCaptcha()
          }
          setIsLoading(false)
        } else if (res.status === 200) {

          localStorage.setItem(
            "TOKEN_INFO",
            JSON.stringify({
              accessToken: res.data.token.accessToken,
              expiresIn: res.data.token.expiresIn,
              idToken: res.data.token.idToken,
              tokenType: res.data.token.tokenType,
              refreshToken: res.data.token.refreshToken,
              email: res.data.email,
            }),
          )


          let config = {
            headers: {
              Authorization: res.data.token.idToken,
            },
          }

          AuthService.sessionInfo(config)
            .then(resLog => {
              if (resLog.status === 200) {
                localStorage.setItem("USER_INFO", JSON.stringify(resLog.data))
                pushDataLayerEvent({
                  event: "authentication",
                  category: "login",
                  action: "click",
                  label: "iniciar sesion",
                  nombre: SHA256(resLog.data.name || '').toString(),
                  apellido: SHA256(resLog.data.lastName || '').toString(),
                  correo: SHA256(resLog.data.email || '').toString(),
                  telefono: SHA256(resLog.data.cellPhone || '').toString(),
                  userId: SHA256(resLog.data.numberId || '').toString(),
                })
                pushDataLayerEvent({
                  event: 'login',
                  user_id: resLog.data.usuarioId? resLog.data.usuarioId : undefined
                })

                try {
                  window.dataLayer.push({
                    event: "GAEdadUsuario",
                    value: resLog.data.birthdate,
                  })
                } catch (e) {
                  console.error(e)
                }

                if (res.data.forceChangePassword) {
                  localStorage.setItem("tempPass", inputPass)
                }

                if (isAdviser(res.data.token.idToken)) {
                  window.location.href = "/callcenter/"
                } else {
                  nextRedirect()
                }
              } else {
                console.log(resLog)
              }
            })
            .catch(e => console.log(e))
        } else {
          props.setModalActive(
            <StandardModal
              title="¡Ups!"
              subtitle=""
              description="Ha ocurrido un error, intentalo mas tarde."
              noButton={true}
              click={() => {
                props.setModalActive(<></>)
              }}
            />,
          )
          setIsLoading(false)
        }
      })
      .finally(() => {
        handleReloadCaptcha()
      })
  }


  useEffect(() => {
    const isFromExternalLinkState =
      window.location?.hash === "#estado-registro" || false

    if (isFromExternalLinkState) {
      props.setModalActive(
        <StateUserModal setModalActive={props.setModalActive} />,
      )
    }

  }, [])


  useEffect(() => {
    localStorage.removeItem("TOKEN_INFO")
    localStorage.removeItem("USER_INFO")
    localStorage.removeItem("SHOWED_POPUP")

    recaptchaRef.current.execute()
    let intervalCaptcha = setTimeout(
      setInterval(handleReloadCaptcha, 120000),
      110000,
    )

    return () => {
      clearInterval(intervalCaptcha)
    }
  }, [])

  return (
    <div className="f-login">
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={reCaptchaKey.key}
      />
      <div className="f-login-content">
        <div className="f-login-left">
          <div className="f-login-info">
            <h1 className="f-login-title">
              {process.env.LOCALE === "es-PY" ||
              process.env.LOCALE === "es-AR" ||
              process.env.LOCALE === "es-UY"
                ? "Iniciá sesión"
                : "Inicia sesión"}
            </h1>
            <p className="f-login-subtitle">CON TU CUENTA</p>
          </div>
          <form className="f-login-form" onSubmit={handleSubmit(onSubmitLogin)}>
            <div className="f-login-form-group-input f-login-form-group-input--username">
              <label className="f-login-form-label">CORREO O CELULAR</label>
              <input
                className={`f-login-form-input ${
                  errors.username ? "f-login-form-input--error" : ""
                }`}
                name="username"
                type="text"
                maxLength="50"
                onChange={e => {
                  if (e.target.value.includes(" ")) {
                    setValue("username", e.target.value.replace(/ /g, ""))
                  }
                  setErrorLogin()
                }}
                ref={register({ required: true, maxLength: "50" })}
              />
            </div>
            <div className="f-login-form-group-input f-login-form-group-input--password">
              <label className="f-login-form-label">CONTRASEÑA</label>
              <input
                className={`f-login-form-input ${
                  errors.password ? "f-login-form-input--error" : ""
                }`}
                name="password"
                type={showPassword ? "text" : "password"}
                maxLength="20"
                ref={register({ required: true, maxLength: "20" })}
              />

              <button
                type="button"
                onClick={e => {
                  e.preventDefault()
                  setShowPassword(!showPassword)
                }}
                className="f-btn-see-password"
              >
                <span className="f-icon icon-see-password"></span>
              </button>
            </div>
            <p className="f-login-form-group-errors">
              {(errors.username?.type === "required" ||
                errors.password?.type === "required") &&
              "  * Debes completar todos los campos"}
              {(errors.username?.type === "maxLength" ||
                errors.password?.type === "maxLength") &&
              "  * Los campos superan la longitud permitida"}
              {errorLogin}
            </p>
            <a
              className="f-link-recover-password"
              href={siteUrl + "/login/recuperar/"}
              onClick={() => {
                pushDataLayerEvent({
                  event: "authentication",
                  category: "login",
                  action: "click",
                  label: "Olvidé mi contraseña",
                })
              }}
            >
              ¿Olvidaste tu contraseña?
            </a>
            <Button
              type="submit"
              title={"Iniciar sesión"}
              className={`new-dark-blue short f-btn-form-submit ${
                isLoading ? "f-btn-form-submit--disabled" : ""
              }`}
              disabled={isLoading}
            />
          </form>
          <div className="f-login-register-state">
            <p className="f-login-register-state-paragraph">
              {process.env.LOCALE === "es-PY" ||
              process.env.LOCALE === "es-AR" ||
              process.env.LOCALE === "es-UY"
                ? "Si sos menor de edad y querés conocer cuál es el estado de tu registro: "
                : "Si eres menor de edad y quieres conocer cuál es el estado de tu registro:"}
            </p>
            <button
              className="f-login-register-state-btn"
              onClick={() => {
                pushDataLayerEvent({
                  event: "authentication",
                  category: "login",
                  action: "click",
                  label: "Conoce el estado de tu registro",
                })

                props.setModalActive(
                  <StateUserModal setModalActive={props.setModalActive} />,
                )
              }
              }
            >
              {process.env.LOCALE === "es-PY" ||
              process.env.LOCALE === "es-AR" ||
              process.env.LOCALE === "es-UY"
                ? "Conocé"
                : "Conoce"}{" "}
              el estado de tu registro
            </button>
          </div>
        </div>
        <div className="f-login-right">
          <div className="f-top-section">
            <p className="f-section-right-title">
              {process.env.LOCALE === "es-PY" ||
              process.env.LOCALE === "es-AR" ||
              process.env.LOCALE === "es-UY"
                ? "¿Todavía no te registraste? "
                : "¿No te has registrado?"}
            </p>
            <p className="f-section-right-subtitle">
              {process.env.LOCALE === "es-PY" ||
              process.env.LOCALE === "es-AR" ||
              process.env.LOCALE === "es-UY"
                ? "Comenzá ahora"
                : "Comienza ahora"}
            </p>

            <Button
              className=" f-btn new-dark-blue  short"
              onClick={() => {
                window.location.href = siteUrl + "/registro"
              }}
              title={
                process.env.LOCALE === "es-PY" ||
                process.env.LOCALE === "es-AR" ||
                process.env.LOCALE === "es-UY"
                  ? "Registrate"
                  : "Regístrate"
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginContent
